module Meevo.Plugins.CustomBranding {
    "use strict";

    import StorageTypeEnum = Meevo.Model.StorageTypeEnum;
    import IStorageFile = Meevo.Model.IStorageFile;
    import MeevoFile = Meevo.Model.MeevoFile;

    /**
     * Page Section of Custom Branding
     */
    export class PageSection extends CustomBrandingBaseSection {

        public stockImages: Array<MeevoFile>;
        public selectedTab: number;

        constructor(params: Meevo.Model.ISectionParamsBaseDataService) {
            super(params);
        }

        /**
         * Here you can implement needed logic before saving the form
         */
        public preSave(): void {

            this.busyService.start();
            this.model['imagesSavedToStoragePromise'] = this.$q.all([
                this.saveImageToStorage(this.model.pageDisplayLogoImageObject),
                this.saveImageToStorage(this.model.pageCustomBackgroundImageObject)
                ])
                .then((pageDisplayLogoImageObject: Meevo.Model.IStorageFile | any) => { })
                .catch(error => {
                    this.loggingService.trace(error.statusText);
                })
                .finally(() => {
                    this.busyService.stop();
                });
            if (Model.Guard.isSomething(this.model.pageDisplayLogoImageObject))
                this.model.pageDisplayLogoImage = this.model.pageDisplayLogoImageObject.fileGuid;
            if (Model.Guard.isSomething(this.model.pageCustomBackgroundImageObject))
            this.model.pageCustomBackgroundImage = this.model.pageCustomBackgroundImageObject.fileGuid;

            this.checkForUploadedImage()
        }

        public checkForUploadedImage(): void {
            if (!this.model.pageDisplayLogoImage && this.model.pageDisplayLogo) {
                this.modalService.alert('MESSAGE_CUSTOM_BRANDING_NO_LOGO_UPLOADED');
                this.model.pageDisplayLogo = false;
            }
        }

        /**
         * Handles retrieval of the item from the data service (if it hasn't already been loaded)
         */
        public activate(): void {
            super.activate();

            this.selectedTab = this.model.pageSelectedBackgroundImageOption - 1;

            this.busyService.start();

            this.$q.all([
            this.getImageUrl(StorageTypeEnum.CustomBrandingLogoImage, this.model.pageDisplayLogoImage),
            this.getImageUrl(StorageTypeEnum.CustomBrandingBackgroundImage, this.model.pageCustomBackgroundImage),
            this.getStockImages()
            ])
                //.then((pageDisplayLogoImageObject: Meevo.Model.IStorageFile | any) => {
                //    this.model.pageDisplayLogoImageObject = pageDisplayLogoImageObject.data || {};
                //})
                .then((response: Array<IStorageFile | any>) => {
                    let [pageDisplayLogoImageObject, pageCustomBackgroundImageObject, stockImages] = response,
                        stockImagesArray: Array<MeevoFile> = [];

                    this.model.pageDisplayLogoImageObject = pageDisplayLogoImageObject.data || {};
                    this.model.pageCustomBackgroundImageObject = pageCustomBackgroundImageObject.data || {};
                    for (let image in stockImages.data) {
                        stockImagesArray.push(stockImages.data[image]);
                    }

                    // select the first stock image by default
                    if (!this.model.stockBackgroundImage) {

                        if (stockImagesArray.length == 0) {
                            console.log("Could not find stock background images");
                            return;
                        } else {
                            this.model.stockBackgroundImage = stockImagesArray[0].fileGuid;
                        }

                    }

                    this.stockImages = stockImagesArray;
                })
                .catch(error => {
                    this.loggingService.trace(error.statusText);
                })
                .finally(() => {
                    this.busyService.stop();
                });
        }

        /**
         * Select tab
         * @param {ITab} tab
         * */
        public selectTab(tab: ITab): void {
            this.model.pageSelectedBackgroundImageOption = tab.tabId;
            this.selectedTab = this.model.pageSelectedBackgroundImageOption - 1
        }

        /**
         * Set active tab
         * */
        public setActiveTab(): number {
            return this.model.pageSelectedBackgroundImageOption - 1;
        }

        /**
         * Get all stock images
         */
        private getStockImages(): angular.IPromise<any> {
            return this.dataService.customMethodData(`api/storage/StockImages/${StorageTypeEnum.StockImage}`, 'GET', null);
        }
    }

}